import React from 'react';
import { motion, useScroll, useSpring, useReducedMotion } from 'motion/react';

/**
 * ScrollProgress
 * Ambient top-line progress bar indicating viewport scrollytelling depth.
 */
export default function ScrollProgress() {
  const shouldReduceMotion = useReducedMotion();
  const { scrollYProgress } = useScroll();
  
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      className="lp-global-scroll-progress"
      style={{
        scaleX: shouldReduceMotion ? scrollYProgress : scaleX,
      }}
      aria-hidden="true"
    />
  );
}
